import BaseApi from '@/api/controller/base';

const PAYSTUB_API_URL = 'paystub/';

class PaystubApi extends BaseApi {
  constructor() {
    super(PAYSTUB_API_URL);
  }

  get(id) {
    return this.api.get(`${id}`);
  }

  save(paystub) {
    return this.api.post('', paystub);
  }
}

const apiInstance = new PaystubApi();
export { PaystubApi, apiInstance };
export default apiInstance;
